import { useEffect, useState } from "react";
import { ModalHeader, ModalBody, useDisclosure } from "@nextui-org/react";
import {
  FooterFilterMobile,
  LoaderCustom,
  MachineOfStore,
  ModelNext,
} from "../../components";
import { useGetMachineOfStoreApi } from "../../hooks";
import { useAccountOfStore } from "../../store";
import { Button, Input, Modal, Space, Table } from "antd";
import toast from "react-hot-toast";
import { MdDelete } from "react-icons/md";
import { HiPencilAlt } from "react-icons/hi";
import { useCreateMachineApi } from "../../hooks/machine/useCreateMachineApi";
import { useDeleteMachineApi } from "../../hooks/machine/useDeleteMachineApi";
import { useUpdateMachineApi } from "../../hooks/machine/useUpdateMachineApi";
import FooterMobile from "../../components/common/FooterMobile";

export default function MachineOfStoreManage() {
  // state
  const [isLoader, setIsLoader] = useState(false);
  const [users, setUsers] = useState<any>([]);
  const [isModalOpenUpdate, setIsModalOpenUpdate] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [infoUpdate, setInfoUpdate] = useState<any>();

  // state info create
  const [infoStore, setInfoStore] = useState<any>({
    userId: "",
    hddSr: "",
    userName: "",
    pgmType: "",
    userGroup: "",
    userLevel: "",
    password: "",
  });

  const [infoUpdateStore, setInfoUpdateStore] = useState<any>({
    hddSr: "",
    userName: "",
    pgmType: "",
    userGroup: "",
    userLevel: "",
    password: "",
    reload: "",
  });

  const { mutate: $createNewMachine, isPending: isPendingCreate } =
    useCreateMachineApi();
  const { mutate: $updateMachine } = useUpdateMachineApi();
  const { mutate: $deleteMachine } = useDeleteMachineApi();

  // api get store
  const { machineOfStore, isLoading } = useGetMachineOfStoreApi();

  const { storeId } = useAccountOfStore();

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleDelete = async (id: any) => {
    $deleteMachine(id, {
      onSuccess: () => {
        toast.success("Delete Store Successfully");
        // setIsModalOpenUpdate(false);
        return;
      },
      onError: () => {
        toast.error("Delete Store Failure");
        return;
      },
    });
  };

  const handleOk = async () => {
    $createNewMachine(
      {
        ...infoStore,
        userGroup: storeId,
      },
      {
        onSuccess: () => {
          toast.success("Create Store success");
          setIsModalOpen(false);
          return;
        },
        onError: () => {
          toast.error("Create Store failure");
          setIsModalOpen(false);
          return;
        },
      }
    );
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    setIsLoader(true);
    setTimeout(() => {
      setIsLoader(false);
    }, 200);
  }, []);

  useEffect(() => {
    if (machineOfStore?.data?.length > 0) {
      const storeConvert = machineOfStore?.data?.map((item: any) => {
        return {
          id: item?.groupId,
          userId: item?.userId,
          userName: item?.userName,
          pgmType: item?.pgmType,
          password: item?.password,
          userLevel: item?.userLevel,
          hddSr: item?.hddSr,
        };
      });
      setUsers(storeConvert);
    }
  }, [machineOfStore, isLoading]);

  const handleOkUpdate = async () => {
    $updateMachine(
      {
        ...infoUpdateStore,
        userGroup: storeId,
        userId: infoUpdate,
        hddSr: infoUpdateStore?.hddSr ? infoUpdateStore?.hddSr : "",
        userLevel: infoUpdateStore?.userLevel ? infoUpdateStore?.userLevel : "",
      },
      {
        onSuccess: () => {
          toast.success("Update Machine Success");
          setIsModalOpenUpdate(false);
          // setType("");
          return;
        },
        onError: () => {
          toast.error("Update Machine Failure");
          setIsModalOpenUpdate(false);
          // setType("");
          return;
        },
      }
    );
  };

  const {
    isOpen: isOpenDetailMachine,
    onOpen: onOpenDetailMachine,
    onOpenChange: onOpenChangeDetailMachine,
  } = useDisclosure();

  const handleCancelUpdate = () => {
    setIsModalOpenUpdate(false);
  };

  const columns = [
    {
      title: "MACHINE ID",
      dataIndex: "userId",
      key: "userId",
    },
    {
      title: "NAME",
      dataIndex: "userName",
      key: "userName",
    },
    {
      title: "TYPE",
      dataIndex: "pgmType",
      key: "pgmType",
    },
    {
      title: "PASSWORD",
      dataIndex: "password",
      key: "password",
    },
    {
      title: "LEVEL",
      dataIndex: "userLevel",
      key: "userLevel",
    },
    {
      title: "HDD",
      dataIndex: "hddSr",
      key: "hddSr",
    },
    {
      title: "ACTION",
      dataIndex: "",
      key: "action",
      render: (_: any, record: any) => (
        <Space size="large">
          <div
            className="cursor-pointer hover:underline font-medium bg-blue-500 bg-opacity-20 h-full flex justify-center items-center p-[6px] rounded-md"
            onClick={() => {
              {
                setInfoUpdate(record?.userId);
                setInfoUpdateStore({
                  userId: record?.userId,
                  hddSr: record?.hddSr,
                  userName: record?.userName,
                  pgmType: record?.pgmType,
                  userGroup: record?.userGroup,
                  userLevel: record?.userLevel,
                  password: record?.password,
                  reload: record?.userId,
                });
                setIsModalOpenUpdate(true);
              }
            }}
          >
            <HiPencilAlt className="xl:text-2xl text-xl text-blue-500 cursor-pointer"></HiPencilAlt>
          </div>
          <div
            className="cursor-pointer hover:underline font-medium bg-red-500 bg-opacity-20 h-full flex justify-center items-center p-[6px] rounded-md"
            onClick={() => {
              {
                handleDelete(record?.userId);
              }
            }}
          >
            <MdDelete className="xl:text-2xl text-xl text-red-500 cursor-pointer" />
          </div>
        </Space>
      ),
    },
  ];

  return (
    <>
      {/* Create new store */}
      <Modal
        okButtonProps={{ style: { backgroundColor: "black" } }}
        title="Create New Machine"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <div className="flex flex-col gap-4">
          <Input
            onChange={(e) => {
              setInfoStore({ ...infoStore, grade: e.target.value });
            }}
            defaultValue={storeId}
            disabled={true}
            placeholder="userGroup"
          />
          <Input
            onChange={(e) => {
              setInfoStore({ ...infoStore, userId: e.target.value });
            }}
            placeholder="userId"
          />
          <Input
            onChange={(e) => {
              setInfoStore({ ...infoStore, hddSr: e.target.value });
            }}
            placeholder="hddSr"
          />
          <Input
            onChange={(e) => {
              setInfoStore({ ...infoStore, userName: e.target.value });
            }}
            placeholder="userName"
          />
          <Input
            onChange={(e) => {
              setInfoStore({ ...infoStore, pgmType: e.target.value });
            }}
            placeholder="pgmType (STD)"
          />
          <Input
            onChange={(e) => {
              setInfoStore({ ...infoStore, userLevel: e.target.value });
            }}
            placeholder="userLevel (HIGH)"
          />
          <Input
            onChange={(e) => {
              setInfoStore({ ...infoStore, password: e.target.value });
            }}
            placeholder="password"
          />
          <div className="flex items-center my-2">
            {isPendingCreate && (
              <span className="font-semibold">Loading...</span>
            )}
          </div>
        </div>
      </Modal>

      {/* Update store */}
      <Modal
        okButtonProps={{ style: { backgroundColor: "black" } }}
        title="Update Store"
        open={isModalOpenUpdate}
        onOk={handleOkUpdate}
        onCancel={handleCancelUpdate}
        key={infoUpdate}
      >
        <div className="flex flex-col gap-4">
          <Input
            onChange={(e) => {
              setInfoUpdateStore((infoStore: any) => {
                return { ...infoStore, grade: e.target.value };
              });
            }}
            defaultValue={storeId}
            disabled={true}
            placeholder="userGroup"
          />
          <Input
            onChange={(e) => {
              setInfoUpdateStore((infoStore: any) => {
                return { ...infoStore, userId: e.target.value };
              });
            }}
            defaultValue={infoUpdateStore?.userId}
            placeholder="userId"
            disabled={true}
          />
          <Input
            onChange={(e) => {
              setInfoUpdateStore((infoStore: any) => {
                return { ...infoStore, hddSr: e.target.value };
              });
            }}
            defaultValue={infoUpdateStore?.hddSr}
            placeholder="hddSr"
          />
          <Input
            onChange={(e) => {
              setInfoUpdateStore((infoStore: any) => {
                return { ...infoStore, userName: e.target.value };
              });
            }}
            defaultValue={infoUpdateStore?.userName}
            placeholder="userName"
          />
          <Input
            onChange={(e) => {
              setInfoUpdateStore((infoStore: any) => {
                return { ...infoStore, pgmType: e.target.value };
              });
            }}
            defaultValue={infoUpdateStore?.pgmType}
            placeholder="pgmType (STD)"
          />
          <Input
            onChange={(e) => {
              setInfoUpdateStore((infoStore: any) => {
                return { ...infoStore, userLevel: e.target.value };
              });
            }}
            defaultValue={infoUpdateStore?.userLevel}
            placeholder="userLevel (HIGH)"
          />
          <Input
            onChange={(e) => {
              setInfoUpdateStore((infoStore: any) => {
                return { ...infoStore, password: e.target.value };
              });
            }}
            defaultValue={infoUpdateStore?.password}
            placeholder="password"
          />
        </div>
      </Modal>

      {/* machine */}
      <ModelNext
        isOpen={isOpenDetailMachine}
        onOpen={onOpenDetailMachine}
        onOpenChange={onOpenChangeDetailMachine}
      >
        <ModalHeader className="flex flex-col gap-1 lg:text-base text-base text-photo-time-pink-light">
          Machine of Store
        </ModalHeader>
        <ModalBody>
          <MachineOfStore />
        </ModalBody>
      </ModelNext>

      {isLoader && <LoaderCustom></LoaderCustom>}
      <div className="w-[100%] p-[16px] md:pb-2 font-semibold text-ok-travel-green mb-2 max-md:mb-0 border-b-[1.5px] md:mb-4">
        <div className="flex max-lg:flex-col lg:items-center max-lg:mt-2 justify-between xl:mb-7 lg:mb-5 mb-4 max-md:flex max-md:flex-row max-md:items-center">
          <span className="uppercase xl:text-xl text-base font-semibold text-gray-600">
            MANAGE MACHINE
          </span>
          <div>
            <Button
              onClick={showModal}
              color="default"
              variant="solid"
              size="middle"
            >
              <span className=" max-lg:text-sm max-sm:text-xs">
                CREATE MACHINE
              </span>
            </Button>
          </div>
        </div>
      </div>
      <div className="mt-4 px-[16px] md:px-[0px] max-md:hidden">
        <Table dataSource={users} columns={columns} pagination={false}></Table>
      </div>
      <div className="md:hidden flex flex-col px-[8px] xl:gap-6 gap-4">
        {users &&
          users?.map((item: any, index: number) => {
            return (
              <div
                key={index}
                className="flex flex-col w-full bg-white border-[1px] border-gray-200 sm:min-h-[20vh] max-sm:min-h-[20vh]"
              >
                <div className="w-full sm:h-[10vh] max-sm:h-[8vh] bg-gray-200 flex items-center justify-between sm:p-[12px] p-[10px]">
                  <div className="uppercase font-semibold text-gray-600">
                    {item?.userId}
                  </div>
                  <div className="flex items-center gap-4 h-full">
                    <div
                      className="cursor-pointer hover:underline font-medium bg-blue-500 bg-opacity-20 h-full min-w-12 flex justify-center items-center p-[6px] rounded-md"
                      onClick={() => {
                        {
                          setInfoUpdate(item?.userId);
                          setInfoUpdateStore({
                            userId: item?.userId,
                            hddSr: item?.hddSr,
                            userName: item?.userName,
                            pgmType: item?.pgmType,
                            userGroup: item?.userGroup,
                            userLevel: item?.userLevel,
                            password: item?.password,
                            reload: item?.userId,
                          });
                          setIsModalOpenUpdate(true);
                        }
                      }}
                    >
                      <HiPencilAlt className="text-3xl text-blue-700 cursor-pointer"></HiPencilAlt>
                    </div>
                    <div
                      className="cursor-pointer hover:underline font-medium bg-red-500 bg-opacity-20 h-full min-w-12 flex justify-center items-center p-[6px] rounded-md"
                      onClick={() => {
                        {
                          handleDelete(item?.userId);
                        }
                      }}
                    >
                      <MdDelete className="text-3xl text-red-500 cursor-pointer" />
                    </div>
                  </div>
                </div>
                <div className="sm:p-[12px] p-[10px] w-full h-auto flex flex-col sm:gap-5 max-sm:gap-4">
                  <div className="flex items-center sm:gap-6 gap-5">
                    <div className="w-[30%] font-bold text-gray-600">
                      userId:
                    </div>
                    <div className="uppercase text-gray-700">
                      {item?.userId}
                    </div>
                  </div>
                  <div className="flex items-center sm:gap-6 gap-5">
                    <div className="w-[30%] font-bold text-gray-600">
                      hddSr:
                    </div>
                    <div className="uppercase text-gray-700">{item?.hddSr}</div>
                  </div>
                  <div className="flex items-center sm:gap-6 gap-5">
                    <div className="w-[30%] font-bold text-gray-600">
                      userName:
                    </div>
                    <div className="uppercase text-gray-700">
                      {item?.userName}
                    </div>
                  </div>
                  <div className="flex items-center sm:gap-6 gap-5">
                    <div className="w-[30%] font-bold text-gray-600">
                      pgmType:
                    </div>
                    <div className="uppercase text-gray-700">
                      {item?.pgmType}
                    </div>
                  </div>
                  <div className="flex items-center sm:gap-6 gap-5">
                    <div className="w-[30%] font-bold text-gray-600">
                      userLevel:
                    </div>
                    <div className="uppercase text-gray-700">
                      {item?.userLevel}
                    </div>
                  </div>
                  <div className="flex items-center sm:gap-6 gap-5">
                    <div className="w-[30%] font-bold text-gray-600">
                      password:
                    </div>
                    <div className="uppercase text-gray-700">
                      {item?.password}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
      {/* <FooterMobile></FooterMobile> */}
      <FooterFilterMobile></FooterFilterMobile>
    </>
  );
}
